import { render } from "./YunCikuIntroduce.vue?vue&type=template&id=c4f896b2&scoped=true"
import script from "./YunCikuIntroduce.vue?vue&type=script&lang=js"
export * from "./YunCikuIntroduce.vue?vue&type=script&lang=js"

import "./YunCikuIntroduce.vue?vue&type=style&index=0&id=c4f896b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4f896b2"]])

export default __exports__